export default __webpack_public_path__ + "static/5-f3daff515a04c5165d0f48aa1652a76d.png";